import React from 'react';
import { Taxonomy } from '@uncinc/react-drupal-core';

import './style.scss';

const ViewCertifications = ({ onLoadMore, pager, loading, entities, setCurrentPage, ...props }) => {

  return (
    <div className="ViewCertifications">
      {entities.map((entity, index) => {
        const id = entity.getIn(['tid', '0', 'value']);
        const uuid = entity.getIn(['uuid', 0, 'value']);
        const langcode = entity.getIn(['langcode', 0, 'value']);

        return (
          <div key={`${uuid}:${langcode}`}>
            <Taxonomy
              id={id}
              entity={entity}
            />
          </div>
        );
      })}
    </div>
  );
};

export default ViewCertifications;
